export default "__VITE_ASSET__D_PbNkRL__"